// 2026-07-18 - FormuLearning - 스텝별 AI Summary(영/국) 게시 스토어 (이슈 #40)
// 파일 위치: frontend/src/stores/summaryStore.ts
//
// 요약 표시는 CardShell이 전담(헤더 직하, 접힘·펼침 동일). 데이터는 두 경로로 채운다.
// ① 프로젝트 로드 시 GET /projects/{id}/ai-summaries 로 전 스텝 일괄 populate
//    (접힘 카드는 children이 미마운트되므로 중앙 populate가 없으면 헤더가 비어버린다).
// ② 각 StepXCard가 재생성·편집 후 해당 스텝 요약을 갱신 발행.

import { create } from 'zustand'

export interface StepSummary {
  en: string
  ko: string
}

type SummaryMap = Record<number, StepSummary>

interface SummaryState {
  summaries: SummaryMap
  setSummary: (step: number, en?: string | null, ko?: string | null) => void
  setSummaries: (map: SummaryMap) => void
  clearSummaries: () => void
}

export const useSummaryStore = create<SummaryState>((set) => ({
  summaries: {},
  setSummary: (step, en, ko) =>
    set((s) => {
      const next: StepSummary = { en: (en || '').trim(), ko: (ko || '').trim() }
      const cur = s.summaries[step]
      if (cur && cur.en === next.en && cur.ko === next.ko) return s // 동일 값이면 리렌더 억제
      return { summaries: { ...s.summaries, [step]: next } }
    }),
  setSummaries: (map) => set({ summaries: map }),
  clearSummaries: () => set({ summaries: {} }),
}))
